module.exports = "/_next/static/images/blankmonitor-fc04c68935f37b4599bd63a07a276b4f.svg";